module.exports = __webpack_public_path__ + "img/stock4.dff8ccca.png";